import { createContext } from 'react';
import { AuthService } from './types';

export const AuthContext = createContext<AuthService | undefined>(undefined);
